const MAP = {
  available: "Available",
  rented: "Rented",
  service: "In service",
  recovery: "Recovery",
  retired: "Retired",
};

// Status palette is fixed across tenants (Prompt §3).
const STYLES = {
  available: "bg-status-available/15 text-status-available",
  rented: "bg-status-rented/15 text-status-rented",
  service: "bg-status-overdue/15 text-status-overdue",
  recovery: "bg-status-recovery/15 text-status-recovery",
  retired: "bg-status-retired/15 text-status-retired",
};

export default function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium ${STYLES[status] || STYLES.retired}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {MAP[status] || status}
    </span>
  );
}
